const t = {
  name: "Wake",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 3V10H11V3L13 3Z" fill="currentColor"/>
<path d="M4.21988 5.80579L7.41409 9L5.99988 10.4142L2.80566 7.22L4.21988 5.80579Z" fill="currentColor"/>
<path d="M17.9999 10.4142L21.1941 7.22L19.7799 5.80579L16.5857 9L17.9999 10.4142Z" fill="currentColor"/>
<path d="M3 13C1.34315 13 0 14.3431 0 16L0 18C0 19.6569 1.34315 21 3 21L21 21C22.6569 21 24 19.6569 24 18L24 16C24 14.3431 22.6569 13 21 13L3 13Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Wake
};
